<div
  class="container"
  *ngIf="!preloaderActive && totalShipmentsForCurrentProductGroupCount"
>
  <div class="basis-counter-label">
    <div>
      {{ getPluralizedLabel() }}
    </div>
    <prlw-icon
      name="three-dots"
      class="three-dots-icon"
      data-cy="table-open-manage-overlay"
      (click)="eventOpenManageOverlay.emit()"
    ></prlw-icon>
  </div>
</div>
